import { useLocalSearchParamState } from '@Hooks/useLocalSearchParamState';
import { format } from 'date-fns';

export function useSelectedPeriod(defaultPeriod?: Date): [date: Date, setDate: (newDate: Date) => void] {
    const [period, setPeriod] = useLocalSearchParamState('period', parseDate(defaultPeriod || new Date()));
    // Force reading parsed date as correct timezone rather than UTC.
    // https://maggiepint.com/2017/04/11/fixing-javascript-date-web-compatibility-and-reality/
    const date = new Date(`${period}T00:00`);
    function setDate(newDate: Date): void {
        setPeriod(parseDate(newDate));
    }

    function parseDate(date: Date): string {
        return format(date, 'yyyy-MM');
    }

    return [date, setDate];
}
